import { faSave } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from "dompurify"
import saveAs from "file-saver";
import { useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { ExportHTMLtoPDFController } from "../../../../Controllers/Geral/ContratosGerados/ContratosGeradosController";
import UnForm from "../../../Form";

interface htmlQuill {
    editorHtml:string
}

interface IDocHTML {
    setShow: (show: boolean) => void
    html: string

}

interface PropsFormData extends htmlQuill{
    idContrato: number
}

export default function VizualizarContratoModal(props: IDocHTML) {
    
    const y = props.html
    const cleanHTML = DOMPurify.sanitize( y );
    const [loading, setLoading] = useState(false);

    const handleSubmitHtml: SubmitHandler<PropsFormData> = (formData, event) => {
        const formEvent = event?.nativeEvent as SubmitEvent;
        const buttonElement = formEvent?.submitter as HTMLButtonElement;
        if(buttonElement?.name === 'gerarPdf') {
            setLoading(true);
            ExportHTMLtoPDFController({strHTML: props.html}).then(res => { 
                saveAs(res, `Contrato` )
                props.setShow(false);
            })
            .catch(() => { 
                setLoading(false);
            })
        } 
    }

    return (
        <div>
            
                <UnForm 
                handleSubmit={handleSubmitHtml}
                className="w-100 align-itens-center mt-5"
                >   
                    <div className="form-group">
                        <div className="custom-scroll h-100 border p-1" dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(cleanHTML)
                        }} />   
                    </div>
                    <div className="row mb-3 flex-wrap d-flex align-items-center flex-column m-0">
                            <UnForm.SubmitButton
                                name="gerarPdf"
                                //noDiv={true}
                                className="btn btn-outline-primary font-weight-bold d-flex col-4 justify-content-center mb-3"
                                icon={faSave}
                                color="primary"
                                disabled={loading}
                            >
                                Gerar PDF
                            </UnForm.SubmitButton>
                    </div>
                </UnForm>    
            
        </div>
    )
}